import { AwsIntegrationView } from "../gql";

export type UsedByItemType = "Stack" | "Module" | "Scan";

export type UsedByRow = {
  id: string;
  name: string;
  type: UsedByItemType;
  spaceDetails: { id: string; name: string };
  href: string;
};

export const stackToUsedByRow = (
  stack: AwsIntegrationView["attachedStacks"][number]
): UsedByRow => ({
  id: stack.id,
  name: stack.stackName,
  type: stack.isModule ? "Module" : "Stack",
  spaceDetails: stack.spaceDetails,
  href: `/${stack.isModule ? "module" : "stack"}/${stack.stackId}`,
});

export const scanToUsedByRow = (scan: AwsIntegrationView["attachedScans"][number]): UsedByRow => ({
  id: scan.scanId,
  name: scan.scanName,
  type: "Scan",
  spaceDetails: scan.spaceDetails,
  href: `/resources/scans/${scan.scanId}`,
});
